import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import { aboutIcons } from "./aboutIcons";
import { expertiseContent } from "./aboutContent";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const AboutExpertise = () => (
  <section
    className="bg-gray-50 py-14 lg:py-20"
    aria-labelledby="about-expertise-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="about-expertise-heading"
        title={expertiseContent.title}
        subtitle={expertiseContent.subtitle}
      />
      <p className="mx-auto max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {expertiseContent.intro}
      </p>
      <motion.ul
        className="mt-8 grid list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2 lg:grid-cols-4"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {expertiseContent.areas.map((area) => {
          const Icon = aboutIcons[area.icon];
          return (
            <motion.li
              key={area.name}
              variants={itemVariants}
              className="brand-card"
            >
              <Link
                to={area.to}
                className="flex h-full items-center gap-4 p-5 rounded-[inherit] text-inherit hover:text-inherit focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-orange)]"
              >
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                  <Icon aria-hidden="true" className="h-5 w-5" />
                </span>
                <span className="text-sm md:text-base font-semibold text-gray-900">
                  {area.name}
                </span>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>
      <p className="mx-auto mt-8 max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {expertiseContent.outro}
      </p>
    </div>
  </section>
);

export default AboutExpertise;
